"use strict";
(() => {
    const CART_ICON = '<svg aria-hidden="true" focusable="false" role="presentation" class="afs-cart-bag" viewBox="0 0 24 24"><path d="M19.884 21.897a.601.601 0 0 1-.439.186h-15a.6.6 0 0 1-.439-.186.601.601 0 0 1-.186-.439v-15a.6.6 0 0 1 .186-.439.601.601 0 0 1 .439-.186h3.75c0-1.028.368-1.911 1.104-2.646.735-.735 1.618-1.104 2.646-1.104s1.911.368 2.646 1.104c.735.736 1.104 1.618 1.104 2.646h3.75a.6.6 0 0 1 .439.186.601.601 0 0 1 .186.439v15a.604.604 0 0 1-.186.439zM18.819 7.083h-3.125v2.5a.598.598 0 0 1-.186.439c-.124.124-.271.186-.439.186s-.315-.062-.439-.186a.6.6 0 0 1-.186-.439v-2.5h-5v2.5a.598.598 0 0 1-.186.439c-.124.124-.271.186-.439.186s-.315-.062-.439-.186a.6.6 0 0 1-.186-.439v-2.5H5.069v13.75h13.75V7.083zm-8.642-3.018a2.409 2.409 0 0 0-.733 1.768h5c0-.69-.244-1.279-.732-1.768s-1.077-.732-1.768-.732-1.279.244-1.767.732z"></path></svg>';
    const MONEY_FORMAT = "€{{amount_with_comma_separator}}";

    const FormatMoney = (cents, format, currency = "") => {
        const value = Number(cents)

        if (!Number.isFinite(value)) return ""

        const amount = value / 100

        const formatNumber = (decimals, thousands, decimal) => {
            const fixed = amount.toFixed(decimals)
            const parts = fixed.split(".")
            const integer = parts.shift() || ""
            const fraction = parts.join(".")

            const whole = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands)

            return decimals ? `${whole}${decimal}${fraction}` : whole
        }

        const replacements = {
            amount: formatNumber(2, ",", "."),
            amount_no_decimals: formatNumber(0, ",", "."),
            amount_with_comma_separator: formatNumber(2, ".", ","),
            amount_with_space_separator: formatNumber(2, " ", ","),
            amount_with_period_and_space_separator: formatNumber(2, " ", "."),
            amount_no_decimals_with_comma_separator: formatNumber(0, ".", ","),
            amount_no_decimals_with_space_separator: formatNumber(0, " ", "."),
            amount_with_apostrophe_separator: formatNumber(2, "'", ".")
        }

        if (!format) {
            return `${currency}${replacements.amount}`
        }

        return format.replace(
            /\{\{\s*(\w+)\s*\}\}/g,
            (_, key) => replacements[key] ?? ""
        )
    }

    function SelectedOrFirstAvailableVariant(product, selectedOptions) {
        if (
            !product?.variants ||
            !Array.isArray(product.variants) ||
            product.variants.length === 0
        ) {
            return null
        }

        const isAvailable = v => {
            return v?.availableForSale === true || v?.available === true
        }

        const getValue = (variant, index) => {
            if (Array.isArray(variant?.selectedOptions)) {
                return variant.selectedOptions?.[index]?.value ?? null
            }
            if (index === 0) return variant?.option1 ?? null
            if (index === 1) return variant?.option2 ?? null
            if (index === 2) return variant?.option3 ?? null
            return null
        }

        // 1. Try match selected options first (strict match)
        if (selectedOptions?.length) {
            const matched = product.variants.find(v => {
                if (!isAvailable(v)) {
                    return false
                }

                return selectedOptions.every((val, idx) => {
                    if (!val) {
                        return true
                    }

                    return getValue(v, idx) === val
                })
            })

            if (matched) {
                return matched
            }
        }

        // 2. Fallback → first available variant
        return product.variants.find(isAvailable) || product.variants[0] || null
    }

    function PID(gid) {
        if (!gid) return null;

        // If already a numeric ID, return as-is
        if (/^\d+$/.test(gid)) {
            return gid;
        }

        // Extract ID from GID format: gid://shopify/Type/ID
        const match = gid.match(/gid:\/\/shopify\/[^/]+\/(.+)$/);

        if (match && match[1]) {
            return match[1];
        }

        // If no match, return original
        return gid;
    }

    function RegisterAFSHook() {
        if (window.AFS && window.AFS.hooks && typeof window.AFS.hooks.register === 'function') {
            // console.log("Registering AFS hooks");
            AFS.hooks.register({
                id: 'wishlist-products-details',
                subscribe(event) {
                    event.on('product:beforeRender', function (ctx) {
                        const product = ctx.data;
                        if (product && product.id) {
                            var html = `
                            <div data-wlh-id="${PID(product.id)}" 
                                data-wlh-link="${product.handle}"
                                data-wlh-variantid="${product.variants?.[0].id}" 
                                data-wlh-name="${product.title}" 
                                data-wlh-image="${product.imageUrl ?? product.featuredImage?.url}"
                                class="wishlist-hero-custom-button wishlisthero-floating" 
                                data-wlh-mode="icon_only"
                                data-wlh-view="Collection"
                                style="left: auto;">
                            </div>
                        `;
                            ctx.appendHtml('product.imageSection', html);
                        }
                    });
                },
                enabled: true,
            });

            AFS.hooks.register({
                id: 'add-title-vendor',
                subscribe(event) {
                    event.on('product:beforeRender', function (ctx) {
                        const product = ctx.data;
                        let html = "";
                        if (product && product.vendor) {
                            html += `<div class="afs-hooks__vendor">${product.vendor}</div>`;
                        }
                        if (product && product.title) {
                            html += `<a class="afs-hooks__title" aria-label="${product.title}" href="${product.handle}">${product.title}</a>`;
                        }

                        const variant = SelectedOrFirstAvailableVariant(product);
                        if (product && variant) {
                            const price = Number(variant?.price ?? 0) * 100;
                            const compareAt = Number(variant?.compareAtPrice ?? variant?.compare_at_price ?? 0) * 100;
                            const onSale = price < compareAt;
                            const strikethroughPrice = onSale ? `<s class="afs-product-price__was money">${FormatMoney(compareAt, MONEY_FORMAT)}</s>` : '';
                            html += `<div class="afs-hooks__price ${onSale ? 'afs-sale-price' : ''}">
                                <span class="afs-product-price__current money">${FormatMoney(price, MONEY_FORMAT)}</span>
                                ${strikethroughPrice}
                                </div>
                            `;
                        }
                        ctx.appendHtml('product.infoSection', html);
                    });
                },
                enabled: true
            });

            AFS.hooks.register({
                id: 'remove-title-vendor',
                subscribe(event) {
                    event.on('products:afterRender', function (ctx) {
                        document.querySelectorAll(".afs-product-card").forEach(function (card) {
                            try {
                                const title = card.querySelector(".afs-product-card__title");
                                const vendor = card.querySelector(".afs-product-card__vendor");
                                const price = card.querySelector(".afs-product-card__price");

                                title?.remove();
                                vendor?.remove();
                                price?.remove();
                            } catch (e) {
                                console.error(e);
                            }

                            try {
                                const text = card.querySelector(".afs-product-card__quick-add-text");

                                if (
                                    text &&
                                    !card.querySelector(".afs-product-card__quick-add-icon")
                                ) {
                                    const icon = document.createElement("div");
                                    icon.className = "afs-product-card__quick-add-icon";
                                    icon.innerHTML = CART_ICON;

                                    text.before(icon);
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        });
                    });
                },
                enabled: true
            });

        }
    }

    document.addEventListener('afs.hooks.ready', RegisterAFSHook);

})()